import React from "react";
import './Welcome.css';
import { useNavigate } from "react-router-dom";

// Welcome page after login
export default function Welcome({ welcomeData }) {
  const navigate = useNavigate()

  const handleClick = () => {
    // showWelcome(false);
    navigate("/haemotherapieNeu");
  }
  // TODO: Survey Page css add
  return (
    <div className="info-wrapper">
      <h2 style={{ color: "dimgray" }}>Qualitätsbericht Hämotherapie</h2>
      <div className="welcome-block">
        <div>
          <h3 className="header">Sehr {welcomeData?.anrede === 'Frau' ? 'geehrte': 'geehrter'} {welcomeData?.anrede} {welcomeData?.titel} {welcomeData?.vorname} {welcomeData?.nachname},<br />
            <br />
            herzlich willkommen auf der Startseite zur Abgabe des Qualitätsberichts Hämotherapie für das Berichtsjahr {welcomeData?.berichtsjahr}.</h3>
        </div>
        <div className="info-block">
          <h4>Die Beantwortung der nachfolgenden Fragen können Sie an beliebiger Stelle unterbrechen. Beim erneuten Einloggen können Sie Ihre Bearbeitung fortsetzen. Wenn Sie die letzte Frage beantwortet haben, wird der Bericht an die Landesärztekammer Rheinland-Pfalz weitergeleitet. Ein Ausdruck Ihrer Antworten ist Ihnen jetzt möglich. Ein erneutes einloggen nach diesem Schritt ist dann erst wieder zum nächsten Berichtsjahr möglich.</h4>
        </div>
        <br />
        <div className="info-block">
          <h4>Bei Fragen kontaktieren Sie bitte Ihre Landesärztekammer Rheinland-Pfalz unter<br />
            06131/28822-76 (Frau Lermen) bzw. -23 (Herr Dr. Hock)<br />
            oder schreiben Sie uns eine E-Mail (haemotherapie@laek-rlp.de).</h4>
        </div>
      </div>
      <div>
        <button onClick={handleClick} className="welcome_btn">Weiter</button>
      </div>
    </div>
  );
}
